import logo from "./logo.svg";
import "./App.css";
import Todolist from "./modules/todo";

function App() {
  return (
    <div className="App">
      <Todolist />
    </div>
  );
}

export default App;
